import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { LinkService } from '../../_services/langhfre.service';

@Component({
  selector: 'app-spell-checker',
  templateUrl: './spell-checker.component.html',
  styleUrls: ['./spell-checker.component.scss']
})
export class SpellCheckerComponent implements OnInit {

  constructor(
    private titleService: Title,
    private metaTagService: Meta,
    private LinkService: LinkService,
  ) {}

  ngOnInit() {
    this.titleService.setTitle("免費的線上拼寫檢查工具——Trinka AI");
    this.metaTagService.updateTag({ name: 'description', content: "Trinka的免費線上拼寫檢查工具可幫助您立即糾正拼寫錯誤和語法。" });
    this.metaTagService.updateTag({ property: 'og:title', content: "免費的線上拼寫檢查工具——Trinka AI" });
    this.metaTagService.updateTag({ property: 'og:description', content: "Trinka的免費線上拼寫檢查工具可幫助您立即糾正拼寫錯誤和語法。" });
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://www.trinka.ai/tw/spell-checker' });
    this.metaTagService.updateTag({ property: 'og:image', content: 'https://www.trinka.ai/tw/assets/images/Trinka.jpg' });
    this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
    this.LinkService.addTag({ rel: 'canonical', href: 'https://www.trinka.ai/tw/spell-checker' });
    this.metaTagService.updateTag({ name: 'language', content: 'zh-tw' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'x-default', href: 'https://www.trinka.ai/spell-checker' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'en-us', href: 'https://www.trinka.ai/spell-checker' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ja-jp', href: 'https://www.trinka.ai/jp/spell-checker' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-cn', href: 'https://trinka.enago.cn/spell-checker' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-tw', href: 'https://www.trinka.ai/tw/spell-checker' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ko-kr', href: 'https://www.trinka.ai/kr/spell-checker' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'es-es', href: 'https://www.trinka.ai/es/corrector-ortografico' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'pt-pt', href: 'https://www.trinka.ai/pt/spell-checker' });
   
  }

  
}
